import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Login from 'Containers/LoginContainer'
import Claim from './ClaimLayout'

const PrimaryLayout = props => {
  return (
    <Switch>
      <Route path='/' exact component={Login} />
      <Route path='/claim' component={Claim} />
      <Redirect to='/' />
    </Switch>
  )
}

export default PrimaryLayout



// WEBPACK FOOTER //
// ./src/Layouts/PrimaryLayout.jsx